import { render, staticRenderFns } from "./insight.vue?vue&type=template&id=2d05076f&scoped=true&"
import script from "./insight.vue?vue&type=script&lang=js&"
export * from "./insight.vue?vue&type=script&lang=js&"
import style0 from "./insight.vue?vue&type=style&index=0&id=2d05076f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05076f",
  null
  
)

export default component.exports